// C:\Users\VRS IT\Music\CleanSlate\cleanslate\src\Services\NotificationService.js

import api,{ baseURL} from "../axios";
import * as signalR from "@microsoft/signalr";

export const createNotificationConnection = (token) => {
    return new signalR.HubConnectionBuilder()
        .withUrl(baseURL + "notificationHub", {
            accessTokenFactory: () => token
        })
        .withAutomaticReconnect()
        .build();
};

export const getUserIdFromToken = (token) => {
    if (!token || typeof token !== "string") return null;

    try {
        const parts = token.split(".");
        if (parts.length < 2) return null;

        const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
        const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
        const decoded = atob(padded);
        const payload = JSON.parse(decoded);

        return payload?.UserID ? String(payload.UserID) : null;
    } catch {
        return null;
    }
};

export const GetNotifications = async (token) => {
    try {
        const response = await api.post("Notifications/GetNotifications", { token });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const MarkAllAsRead = async (token) => {
    try {
        const response = await api.post("Notifications/Mark-all-as-read", { token });
        return response.data;
    } catch (error) {
        throw error;
    }
};

